export const paymentProvidersApiQueryKeys = {
  status: () => ['payment-providers', 'status'] as const,
};
